module.exports = __webpack_public_path__ + "img/dcb71f6.png";